import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SwitchInput } from "@sinch/components/form/SwitchInput/SwitchInput";
import { useMuiController } from "@sinch/components/index";

export const CreateComponentArchivedField: FC = () => {
  const { t } = useTranslation();
  const { field } = useMuiController({ name: "archived" });
  return <SwitchInput {...field} label={t("RateBuilder.archived")} />;
};
